import loadable from "@loadable/component";
export var CheckoutOrderContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-CheckoutOrderContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-CheckoutOrderContext" */"@/common/Contexts/CheckoutOrderContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/CheckoutOrderContext");
    }
    return eval('require.resolve')("@/common/Contexts/CheckoutOrderContext");
  }
});
export var CreditCardCheckoutContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-CreditCardCheckoutContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-CreditCardCheckoutContext" */"@/common/Contexts/CreditCardCheckoutContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/CreditCardCheckoutContext");
    }
    return eval('require.resolve')("@/common/Contexts/CreditCardCheckoutContext");
  }
});
export var AbandonmentTrackingProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-AbandonmentTrackingContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-AbandonmentTrackingContext" */"@/common/Contexts/AbandonmentTrackingContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/AbandonmentTrackingContext");
    }
    return eval('require.resolve')("@/common/Contexts/AbandonmentTrackingContext");
  }
});
export var PostDetailsContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-PostDetailsContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-PostDetailsContext" */"@/common/Contexts/PostDetailsContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/PostDetailsContext");
    }
    return eval('require.resolve')("@/common/Contexts/PostDetailsContext");
  }
});
export var PriceOfferContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-PriceOfferContextProvider";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-PriceOfferContextProvider" */"@/common/Contexts/PriceOfferContextProvider");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/PriceOfferContextProvider");
    }
    return eval('require.resolve')("@/common/Contexts/PriceOfferContextProvider");
  }
});
export var TamaraFinanceContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-TamaraFinanceContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-TamaraFinanceContext" */"@/common/Contexts/TamaraFinanceContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/TamaraFinanceContext");
    }
    return eval('require.resolve')("@/common/Contexts/TamaraFinanceContext");
  }
});
export var TabbyFinanceContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-TabbyFinanceContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-TabbyFinanceContext" */"@/common/Contexts/TabbyFinanceContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/TabbyFinanceContext");
    }
    return eval('require.resolve')("@/common/Contexts/TabbyFinanceContext");
  }
});
export var AmwalFinanceContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-AmwalFinanceContext";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-AmwalFinanceContext" */"@/common/Contexts/AmwalFinanceContext");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/AmwalFinanceContext");
    }
    return eval('require.resolve')("@/common/Contexts/AmwalFinanceContext");
  }
});
export var DhamenContextProvider = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-Contexts-DhamenContextProvider";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-Contexts-DhamenContextProvider" */"@/common/Contexts/DhamenContextProvider");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/Contexts/DhamenContextProvider");
    }
    return eval('require.resolve')("@/common/Contexts/DhamenContextProvider");
  }
});